import { render, staticRenderFns } from "./MeetDetail4.vue?vue&type=template&id=195d5896"
import script from "./MeetDetail4.vue?vue&type=script&lang=js"
export * from "./MeetDetail4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports